import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './demand_histogram.routes';
import Chart from '../../../components/directive/chart/chart.directive';
import DemandPowerService from '../../../components/api/demand_power/demand_power.service';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import chartConfig from './demand_histogram.config';

export class DemandHistogramController {
  /*@ngInject*/
  constructor($stateParams, $filter, $interval, moment, DemandPowerService, DateUtil, CsvUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.DemandPowerService = DemandPowerService;
    this.DateUtil = DateUtil;
    this.moment = moment;
    this.CsvUtil = CsvUtil;

    this.targetDate = this.moment();
    this.maxDate = this.moment().startOf('day').toDate();

    this.downloadFileName = 'demand_histogram.csv';

    this.chartConfig = chartConfig(this, $filter);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.contractPower = config.contract_power;
      this.limitPower = config.limit_power;
      this.targetPower = config.target_power;
      this.billingDay = config.billing_date

      this.updateGraph(this.targetDate, this.billingDay);
    });
  }

  updateGraph(targetDate, billingDate) {
    [this.startDate, this.endDate] = this.DateUtil.getBillingDateDomain(targetDate.toDate(), billingDate);
    this.startDate = this.moment(this.startDate);
    this.endDate = this.moment(this.endDate);

    this.billingDate = this.endDate.clone().add(1, 'days');

    let numberOfDays = this.endDate.diff(this.startDate, 'days');

    this.chart.xAxis[0].removePlotLine('target');
    this.chart.xAxis[0].removePlotLine('limit');
    this.chart.xAxis[0].removePlotLine('contract');

    this.DemandPowerService.show(
      angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(this.startDate, this.endDate)),
      response => {
        this.histogram = this.createHistogram(response.powers);

        if (this.histogram.length > 0) {
          this.chart.xAxis[0].addPlotLine({
            label: '目標電力',
            id: 'target',
            value: this.targetPower,
            color: '#8bc34a',
            width: 2,
            zIndex: 5
          });
          this.chart.xAxis[0].addPlotLine({
            label: '限界電力',
            id: 'limit',
            value: this.limitPower,
            color: '#e67e22',
            width: 2,
            zIndex: 5
          });
          this.chart.xAxis[0].addPlotLine({
            label: '契約電力',
            id: 'contract',
            value: this.contractPower,
            color: '#D32F2F',
            width: 2,
            zIndex: 5
          });

          this.chart.series[1].setData([[this.contractPower, 0]], false);
          this.chart.series[2].setData([[this.limitPower, 0]], false);
          this.chart.series[3].setData([[this.targetPower, 0]], false);
        }

        this.chart.series[0].setData(this.histogram);
        this.chart.reflow();

        this.reversedHist = this.histogram.reverse();
        this.csvData = this.CsvUtil.processDemandHistogram(this.reversedHist);
        this.downloadFileName = this.startDate.format('[demand_histogram_]YYYY-MM[.csv]');
      }
    )
  }

  createHistogram(powers) {
    let x = [];
    let y = [];
    let times = [];

    powers.forEach(power => {
      if (power.missing) {
        return;
      }

      let value = Math.round(power.value);
      let x_index = x.indexOf(value);
      if (x_index === -1) {
        x.push(value);
        y.push(1);
        times.push([power.measured_at]);
      } else {
        y[x_index] += 1;
        times[x_index].push(power.measured_at);
      }
    });

    let data = x.map((value, index) => {
      return { x: value, y: y[index], times: times[index] };
    });

    // x 軸でソート
    return data.sort((a, b) => {
      return a.x - b.x;
    });
  }

  changeMonth(diff) {
    this.targetDate = this.targetDate.add(diff, 'months');
    this.updateGraph(this.targetDate, this.billingDay);
  }
}

export default angular.module('leptonApp.demandHistogram', [uiRouter, moment, DemandPowerService, DateUtil, CsvUtil])
  .config(routing)
  .component('demandHistogram', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./demand_histogram.html'),
    controller: DemandHistogramController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/histogram/demand_histogram.component.js